import React from 'react';

export const InputHiddenField = (props) => {

    const {
        input,
        type,
    } = props;

    return (
        <input {...input} type={type} />
    )
}


// WEBPACK FOOTER //
// ./src/components/fields/field_input_hidden.js